import { render } from "./ResumeSection.vue?vue&type=template&id=63630d7b&scoped=true"
const script = {}

import "./ResumeSection.vue?vue&type=style&index=0&id=63630d7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63630d7b"]])

export default __exports__